import type { ActionName } from 'state/common-form/infos/infos.model';

export type QuoteActionsUiAction = QuoteActionSelected;

export interface QuoteActionSelected {
  type: 'QUOTE_ACTION_SELECTED';
  name: ActionName;
  tabId: string;
}
export function selectQuoteAction(name: ActionName, tabId: string): QuoteActionSelected {
  return {
    type: 'QUOTE_ACTION_SELECTED',
    name,
    tabId,
  };
}
